import { createSlice } from "@reduxjs/toolkit";

const DASHBOARD_STORAGE_KEY = "selectedDashboardKey";

const persistDashboardSelection = (dashboard) => {
  if (typeof window === "undefined" || !window.localStorage) return;
  if (dashboard?.KEY == null) return;

  window.localStorage.setItem(DASHBOARD_STORAGE_KEY, String(dashboard.KEY));
};

const initialState = {
  dashboardOptions: null,
  currentDashboard: null,
  toggleDataAnalyticsButton: false,
  currentDashboardRange: null,
  selectedCard: null,
};

export const dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState,
  reducers: {
    setDashboardOptions: (state, action) => {
      state.dashboardOptions = action.payload;
    },
    setCurrentDashboard: (state, action) => {
      state.currentDashboard = action.payload;
      persistDashboardSelection(action.payload);
    },
    setToggleDataAnalyticsButton: (state, action) => {
      state.toggleDataAnalyticsButton = action.payload;
    },
    setCurrentDashboardRange: (state, action) => {
      state.currentDashboardRange = action.payload;
    },
    setSelectedCard: (state, action) => {
      state.selectedCard = action.payload;
    },
    resetDashboard: () => {
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.removeItem(DASHBOARD_STORAGE_KEY);
      }

      return initialState;
    },
  },
});

export const {
  setDashboardOptions,
  setCurrentDashboard,
  setToggleDataAnalyticsButton,
  setCurrentDashboardRange,
  setSelectedCard,
  resetDashboard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
